import { Link } from "react-router-dom";
import { heroData } from "@/mocks/home";

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src={heroData.heroImageUrl}
        alt="蜜桃影视 - 热门影视资源在线观看平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-4 whitespace-pre-line">
          {heroData.title}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8">
          {heroData.subtitle}
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link
            to="/category/movie"
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {heroData.cta}
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {heroData.secondaryCta}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}